import { FixturePositionData } from './computeFixtureAllocations';

interface FixtureWithPosition {
  id: string;
  translation?: number[] | null;
  rotation?: number | null;
  width?: number | null;
}

/**
 * Builds a Map<fixtureId, FixturePositionData> from an array of fixtures.
 * Only includes fixtures that have valid translation, rotation, and width data.
 */
export function buildFixturePositionMap(fixtures: FixtureWithPosition[]): Map<string, FixturePositionData> {
  const map = new Map<string, FixturePositionData>();
  for (const f of fixtures) {
    if (f.id && f.translation && f.translation.length >= 2 && f.rotation != null && f.width != null && f.width > 0) {
      map.set(f.id, {
        translation: f.translation,
        rotation: f.rotation,
        width: f.width,
      });
    }
  }
  return map;
}
